export default "コード\tコード内容\r\n2\t2点吊り　60°\r\n4\t4点吊り　60°\r\n";